import React, { useContext } from 'react';
import styled from 'styled-components';
import { AuthContext } from 'src/state/providers/AuthProvider';
import { CaseDetailsContext } from '../providers/CaseDetailsProvider';
import { KatAlert } from '@amzn/katal-react';
import ViewCaseForm from './ViewCaseForm';
import { ViewCaseConstants } from 'src/constants/ProjectConstants';
import { logger } from 'src/logger';
import { TranslationContext } from 'src/state/providers/TranslationProvider';

const ViewCaseFormContainer = styled.div`
  margin-top: 0.5rem;
  padding: 1rem 2rem 1rem 2rem; /* top right bottom left  */
  background-color: ${({ theme }) => theme.colors.White};
`;

const ViewCase = () => {
  const userContext = useContext(AuthContext);
  const { caseId, ddmAttributes, caseDetailsResponse } =
    useContext(CaseDetailsContext);

  if (!ddmAttributes || !caseDetailsResponse) {
    logger.error(
      `View Case Response is Invalid for userId: ${userContext.customerId}`,
      { ddmAttributes, caseDetailsResponse },
    );
    const { messageBundle } = useContext(TranslationContext);

    return (
      <KatAlert
        data-testid="ViewCaseErrorBanner"
        description={`${messageBundle.getMessage(
          ViewCaseConstants.ERROR_LOADING_CASE_ID,
        )} ${caseId}`}
        variant="danger"
        persistent
      />
    );
  }

  const { data: formData, documentList } = caseDetailsResponse!;
  const { referralInformation } = formData;

  return (
    <ViewCaseFormContainer data-testid="ViewCaseFormContainer">
      <ViewCaseForm
        formData={formData} //Need to add this from caseDetailsResponse since the data has to be hydrated to viewcase page
        userStaticInformation={referralInformation}
        documentList={documentList}
        createCaseUiSchema={ddmAttributes?.createCaseUiSchema}
        createCaseSchema={ddmAttributes?.createCaseSchema!}
        caseSummarySchema={ddmAttributes?.caseSummarySchema}
        createCaseStaticSchema={ddmAttributes?.createCaseStaticSchema}
      />
    </ViewCaseFormContainer>
  );
};

export default ViewCase;
